export default __webpack_public_path__ + "static/media/karen_profile_pic.ab5fc9a8.png";